import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp12};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.spacing.sp8};
`

export const Bar = styled.div`
  display: flex;
  flex: 1;
  gap: ${props => props.theme.spacing.sp2};
  height: ${props => props.theme.spacing.sp8};
  background-color: transparent;
`

export const BarSegment = styled.div`
  height: 100%;
  width: ${props => props.width}%;
  background-color: ${props => props.color};
  border-radius: 2px;
`

export const Legend = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
